import { render } from "./SlideShowReport.vue?vue&type=template&id=2adcf95b"
import script from "./SlideShowReport.vue?vue&type=script&lang=js"
export * from "./SlideShowReport.vue?vue&type=script&lang=js"

import "./SlideShowReport.vue?vue&type=style&index=0&id=2adcf95b&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__